import { NgModule } from "@angular/core";
import { AppVersionService } from "../../gyzmo-commons/services/appVersion.service";
import { CacheService } from "../../gyzmo-commons/services/cache.service";
import { GeolocationService } from "../../gyzmo-commons/services/geolocation.service";
import { LanguageService } from "../../gyzmo-commons/services/language.service";
import { DaoModule } from "../dao/db/dao.module";
import { WsModule } from "../dao/ws/ws.module";
import { DeliveryService } from "./delivery.service";
import { HourTypeService } from "./hourType.service";
import { OfflineModeService } from "./offlineMode.service";
import { OrderService } from "./order.service";
import { ReturnCheckStatusService } from "./returnCheckStatus.service";
import { UserService } from "./user.service";

@NgModule({
    imports: [
        DaoModule,
        WsModule,
    ],
    providers: [
        AppVersionService,
        UserService,
        OfflineModeService,
        CacheService,
        GeolocationService,
        ReturnCheckStatusService,
        HourTypeService,
        LanguageService,
        OrderService,
        DeliveryService,
    ],
})
export class ServiceModule {
}
